export const autoPrint = async ({ receiptData, ipAddress, port }) => {
  const url = `${process.env.REACT_APP_PRINT_SERVICE_URL}/printReceipt`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        receiptData,
        printerIP: ipAddress,
        printerPort: port,
      }),
    });

    if (!response.ok) {
      throw new Error("Printer error: " + response.status);
    }
    const resJson = await response.json();
    return { ipAddress, ...resJson };

  } catch (error) {
    console.error("Print failed:", error);
    return { ipAddress, success: false, };
  }
};

export const printToIP = async ({ receiptData, ipAddress, port }) => {
  const url = `${process.env.REACT_APP_PRINT_SERVICE_URL}/printReceipt`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        receiptData,
        printerIP: ipAddress,
        printerPort: port,
      }),
    });

    if (!response.ok) {
      throw new Error("Printer error: " + response.status);
    }

    return await response.json();

  } catch (error) {
    console.error("Print failed:", error);
    throw error;
  }
};